import React from 'react';
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle, Slide, useMediaQuery, useTheme,
} from "@material-ui/core";
import {TransitionProps} from "@material-ui/core/transitions/transition";
import {makeStyles} from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    form: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    dialog: {
        alignItems: 'flex-start',
    },
    deleteFlex: {
        flex: 1,
    }
}));

export interface DecisionModalProps
{
    open: boolean;
    message: string;
    onAccept: () => void;
    onCancel: () => void;
}

export default function DecisionModal(props: DecisionModalProps)
{
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const {open, message, onCancel, onAccept} = props;
    const classes = useStyles();

    return (
        <Dialog
            classes={{scrollPaper: classes.dialog}}
            open={open}
            onClose={onCancel}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            TransitionComponent={Transition}
        >
            <DialogTitle>Are you sure?</DialogTitle>

            <DialogContent>
                {message}
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    No
                </Button>
                <Button onClick={onAccept} color="primary">
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}